module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/_redefine.js
// module id = 170
// module chunks = 0